import fetch from "auth/FetchInterceptor";

const actionObjectiveActionPlansService = {};

actionObjectiveActionPlansService.get = function (params = {}) {
	return fetch({
		url: `/v1/rest/action-objectives-action-plans/`,
		method: "get",
		params,
	});
};

actionObjectiveActionPlansService.post = function (data) {
	return fetch({
		url: "/v1/rest/action-objectives-action-plans",
		method: "post",
		data: data,
	});
};

actionObjectiveActionPlansService.postCopyActionObjective = function (data, company_id) {
	return fetch({
		url: `/v1/rest/action-objectives-action-plans-in-company-schema/${company_id}`,
		method: "post",
		data: data,
	});
};

actionObjectiveActionPlansService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/action-objectives-action-plans/${id}`,
		method: "put",
		data: data,
	});
};

actionObjectiveActionPlansService.getById = function (id) {
	return fetch({
		url: `/v1/rest/action-objectives-action-plans/${id}`,
		method: "get",
	});
};

export default actionObjectiveActionPlansService;
